import type { AppState } from '../../state/appState.js';
import type { ComponentDef, Scene, SceneNodeId } from '../../scene/sceneState.js';
import type { LayerDef } from '../../scene/layerState.js';
import type { ActionBase, ActionExecution } from '../commandExecutor.js';
import {
  cloneComponentDef,
  cloneLayerDef,
  cloneSceneNode,
  getSceneTargetFor,
  insertChildId,
} from './shared.js';

export interface RestoreSceneSubtreeAction extends ActionBase<'scene:restoreSubtree'> {
  targetComponentId: string | null;
  rootId: SceneNodeId;
  parentId: SceneNodeId | null;
  index: number;
  nodes: Scene['nodes'];
}

export interface RestoreComponentAction extends ActionBase<'component:restore'> {
  component: ComponentDef;
}

export interface RestoreLayerDefAction extends ActionBase<'layer:restore'> {
  layerDef: LayerDef;
}

export function execRestoreSceneSubtreeFor(
  appState: AppState,
  cmd: RestoreSceneSubtreeAction,
): ActionExecution<void> {
  const target = getSceneTargetFor(appState, cmd.targetComponentId);
  for (const [id, node] of Object.entries(cmd.nodes)) {
    target.scene.nodes[id] = cloneSceneNode(node);
  }
  insertChildId(target.scene, cmd.parentId, cmd.rootId, cmd.index);
  return { result: undefined, undoActions: [], changed: true };
}

export function execRestoreComponentFor(appState: AppState, cmd: RestoreComponentAction): ActionExecution<void> {
  appState.componentLibrary[cmd.component.id] = cloneComponentDef(cmd.component);
  return { result: undefined, undoActions: [], changed: true };
}

export function execRestoreLayerDefFor(appState: AppState, cmd: RestoreLayerDefAction): ActionExecution<void> {
  appState.layerLibrary[cmd.layerDef.id] = cloneLayerDef(cmd.layerDef);
  return { result: undefined, undoActions: [], changed: true };
}
